console.log('env', process.env.GCM_ENVIRONMENT)

export default process.env.GCM_ENVIRONMENT
